/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import { useQuery, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
    showReportMenuVar, activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar, tenantIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import { GET_PROJECT_HIERARCHY } from 'Apollo/Queries/DataRecon';
import Loader from 'views/Shared/components/Loader';
import ErrorView from 'views/Shared/components/ErrorView';
import crossReportImg from 'assets/images/cross-report-black.svg';
import { ReconStatusTypeEnum, ProjectStatusTypeEnum, ModuleEnum } from '../../../../constants';
import Project from '../components/Project';
import CustomTooltip from '../components/CustomTooltip';
import StatusBadge from '../components/StatusBadge';

import '../styles/projects.scss';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

/* function to navigate to Data Recon home page */
const navigateToReconHome = (history, tenantId) => history.push(
    {
        pathname: '/data-recon-home',
        state: {
            tenantId,
        },
    },
);

const navigateToDataLineageUpload = (history, project, tenantId) => history.push({
    pathname: '/data-lineage-upload',
    state: {
        tenantId, project,
    },
});
const navigateToReconResult = (history, project, tenantId) => history.push({
    pathname: '/datareconresult',
    state: {
        tenantId, project,
    },
});

const Projects = () => {
    const history = useHistory();
    const location = useLocation();
    const tenantVar = useReactiveVar(tenantIdVar);
    const [tenantId, setTenantId] = useState(tenantVar);
    const [filterValue, setFilterValue] = useState(location.state.filterValue);
    const [showModal, setShowModal] = useState(false);
    const [dataForUpdate, setDataForUpdate] = useState({});
    const [dataForClone, setDataForClone] = useState({});
    const [toastMessage, setToastMessage] = useState('');
    const [filterString, setFilterString] = useState('');
    const [copyProjectFlag, setCopyProjectFlag] = useState(false);
    const filter = (filterValue === undefined || filterValue === null) ? 'ALL' : filterValue;
    /* apollo query to fetch lists of projects along with subprojects */
    const getProjectHierarchy = useQuery(GET_PROJECT_HIERARCHY, {
        variables: {
            input: {
                getProjectsType: filter,
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });
    const mainData = getProjectHierarchy.data && getProjectHierarchy.data.getProjectsHirachy && getProjectHierarchy.data.getProjectsHirachy.projects;
    const [projects, setProjects] = useState(mainData);
    const [tableDatasource, setTableDatasource] = useState(mainData);
    const getProjectNameSpan = data => (
        <span
            role="presentation"
            onClick={() => { navigateToDataLineageUpload(history, data, tenantId); }}
        >
            {`${data.projectName}`}
        </span>
    );
    const getReconStatusBadge = data => (
        <StatusBadge data={data} navigateToReconResult={navigateToReconResult} history={history} tenantId={tenantId} />
    );
    const breadcrumbItems = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={() => { navigateToReconHome(history, tenantId); }} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">My projects</span>,
        },
    ];
    const actionColumn = [
        {
            Header: '',
            accessor: '',
            minWidth: 35,
            resizable: true,
            Cell: ({ original }) => {
                const props = {
                    data: original,
                    setShowModal,
                    setDataForUpdate,
                    setDataForClone,
                    setCopyProjectFlag,
                    tenantId,
                    getProjectHierarchy,
                    setToastMessage,
                };
                return CustomTooltip(props);
            },
        },
    ];
    /* Parent Projects Table Columns */
    let columns = [
        {
            expander: true,
            Expander: ({ isExpanded, ...rest }) => {
                if (rest.original.children.length > 0) {
                    return (
                        <div>
                            {isExpanded ? (
                                <span className="rt-expander -open" style={{ marginBottom: '0.3rem' }} />
                            ) : (
                                <span className="rt-expander" style={{ marginBottom: '0.3rem' }} />
                            )}
                        </div>
                    );
                }
                return <span className=" rt-td rt-expander" />;
            },
        },
        {
            Header: 'ID',
            accessor: 'projectDisplayId',
            minWidth: 90,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project name',
            accessor: 'projectName',
            minWidth: 150,
            resizable: true,
            sortable: true,
            style: { cursor: 'pointer' },
            Cell: ({ original }) => getProjectNameSpan(original),
        },
        {
            Header: 'Description',
            accessor: 'projectDesc',
            minWidth: 240,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project owner',
            accessor: 'ownerName',
            minWidth: 140,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project Status',
            accessor: 'status',
            minWidth: 105,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Data Reconciliation',
            accessor: 'ReconStatus',
            minWidth: 110,
            resizable: true,
            sortable: true,
            Cell: ({ original }) => getReconStatusBadge(original),
        },
    ];
    columns = columns.concat(actionColumn);
    /* Sub Projects Table Columns */
    let subColumns = [
        {
            expander: true,
            Expander: ({ isExpanded, ...rest }) => {
                if (rest.original.children && rest.original.children.length > 0) {
                    return (
                        <div>
                            {isExpanded ? (
                                <span className="rt-expander -open" style={{ marginBottom: '0.3rem' }} />
                            ) : (
                                <span className="rt-expander" style={{ marginBottom: '0.3rem' }} />
                            )}
                        </div>
                    );
                }
                return <span className=" rt-td rt-expander" />;
            },
        },
        {
            accessor: 'projectDisplayId',
            minWidth: 90,
            resizable: true,
        },
        {
            accessor: 'projectName',
            minWidth: 150,
            resizable: true,
            style: { cursor: 'pointer' },
            Cell: ({ original }) => getProjectNameSpan(original),
        },
        {
            accessor: 'projectDesc',
            minWidth: 240,
            resizable: true,
        },
        {
            accessor: 'ownerName',
            minWidth: 140,
            resizable: true,
        },
        {
            accessor: 'status',
            minWidth: 70,
            resizable: true,
        },
        {
            accessor: 'ReconStatus',
            minWidth: 110,
            resizable: true,
            Cell: ({ original }) => getReconStatusBadge(original),
        },
    ];
    subColumns = subColumns.concat(actionColumn);
    // Need to get filtered data through API
    useEffect(() => {
        let filteredValue;
        switch (filterValue) {
            case 'completedProjects':
                filteredValue = mainData && mainData
                    .filter(e => (e.reconRunStatus === ReconStatusTypeEnum.SUCCESS && e.status === ProjectStatusTypeEnum.OPEN)
                    || (e.status === ProjectStatusTypeEnum.ARCHIVED || e.status === ProjectStatusTypeEnum.RESOLVED));
                break;
            case 'InProgressProjects':
                filteredValue = mainData && mainData
                    .filter(e => (e.reconRunStatus === ReconStatusTypeEnum.INPROGRESS || e.reconRunStatus === ReconStatusTypeEnum.NOTSTARTED)
                    && (e.status === ProjectStatusTypeEnum.OPEN));
                break;
            case 'failedProjects':
                filteredValue = mainData && mainData.filter(e => (e.reconRunStatus === ReconStatusTypeEnum.FAILURE) || (e.status === ProjectStatusTypeEnum.OPEN));
                break;
            default:
                filteredValue = (mainData || []);
                break;
        }
        setProjects(filteredValue);
        setTableDatasource(filteredValue);
    }, [filterValue, mainData]);
    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);
    /* side effect when location.state is changed */
    useEffect(() => {
        setTenantId(location.state.tenantId);
        showReportMenuVar(false);
        setFilterValue(location.state.filterValue);
        activeDataReconMenuVar('projects');
        showDataReconMenusVar(true);
    }, [location.state]);
    /* side effect to set projects when filterString is changed */
    useEffect(() => {
        const searchString = filterString.trim().toLowerCase();
        if (searchString.length > 0) {
            setTableDatasource(projects && projects.filter(e => e.projectName.toLowerCase().match(searchString)));
        } else {
            setTableDatasource(projects || []);
        }
    }, [filterString]);
    useEffect(() => {
        if (tenantVar) {
            setTenantId(tenantVar);
        }
    }, [tenantVar]);

    useEffect(() => {
        getProjectHierarchy.refetch();
    }, [tenantId]);
    if (getProjectHierarchy.loading) {
        return <Loader />;
    }
    if (getProjectHierarchy.error) {
        return <ErrorView />;
    }
    return (
        <Project
            breadcrumbItems={breadcrumbItems}
            showModal={showModal}
            setShowModal={setShowModal}
            dataForUpdate={dataForUpdate}
            tenantId={tenantId}
            dataForClone={dataForClone}
            copyProjectFlag={copyProjectFlag}
            setCopyProjectFlag={setCopyProjectFlag}
            getProjectHierarchy={getProjectHierarchy}
            setToastMessage={setToastMessage}
            toastMessage={toastMessage}
            filterString={filterString}
            setFilterString={setFilterString}
            setDataForClone={setDataForClone}
            setDataForUpdate={setDataForUpdate}
            tableDatasource={tableDatasource}
            columns={columns}
            subColumns={subColumns}
        />
    );
};

export default Projects;
